<div [class.smaller-text]="isSmallText"
  [class.primary]="isPrimary"
  [class.inline] = "isInline"
  class="inner-card">
  <h6 class="inner-card-title">{{title}}</h6>

  @if (growthValue || growthValue === 0) {
    <div class="percent-with-arrow">
      <h1 class="inner-card-value {{color}}">{{ growthValue || growthValue === 0 ? growthValue + '%' : 'N/A' }}</h1>
      @if (growthValue || growthValue !== 0) {
        <i
          class="icon icon-arrow-{{ growthValue > 0 ? 'up rate-up' : 'down rate-down'}}"
          [class.reversed]="isArrowColorReversed">
        </i>
      }
    </div>
  }

  @if (!growthValue) {
    <h1 class="inner-card-value {{color}}">{{ isPrice ? (value | customCurrency) : value }}</h1>
  }

  <div class="inner-card-ng-content">
    <ng-content></ng-content>
  </div>
</div>
